var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 22.5,
    viewBox: "0 0 22.5 22.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_tune",
    "data-name": "Path / tune",
    d: "M3,20.5V23h7.5V20.5H3m0-15V8H15.5V5.5H3m12.5,20V23h10V20.5h-10V18H13v7.5h2.5M8,10.5V13H3v2.5H8V18h2.5V10.5H8m17.5,5V13H13v2.5H25.5m-7.5-5h2.5V8h5V5.5h-5V3H18Z",
    transform: "translate(-3 -3)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTune);
export default __webpack_public_path__ + "static/media/tune.4947d710f0b282cd308f513f805e403b.svg";
export { ForwardRef as ReactComponent };